// 成本价与汇率表单的草稿与换算，字段见 docs/03 3.7、3.8。两者都只增不改，每次提交是一个新版本。
import { pricingInput, type PricingFieldsDraft } from "./pricingDraft";
import type { Errors } from "@/app/useDraft";
import { CURRENCY_ERROR, fromLocalInput, parseMoney, validCurrency } from "@/app/form";
import { channelKind, type Channel, type ChargeOn, type CostPrice, type CurrencyRate, type Input } from "@/app/master";

/** Telegram 通道的成本价只能按送达计（D207 第 6 条），计费类型锁定时的说明。 */
export const TELEGRAM_CHARGE_ON = "Telegram 通道只按送达计成本：未送达的 Telegram 会退款";

/** 通道要求的计费类型：Telegram 只能按送达，其余不限。 */
export function lockedChargeOn(channel?: Channel): "delivered" | undefined {
  return channel && channelKind(channel) === "telegram" ? "delivered" : undefined;
}

export interface CostDraft extends PricingFieldsDraft { supplier_id: string; channel_id: string }

/** 新成本价的草稿；chargeOn 给通道要求的计费类型（Telegram 只能按送达，D207 第 6 条），缺省按提交。 */
export function costDraft(channelId = "", supplierId = "", chargeOn: ChargeOn = "submitted"): CostDraft {
  return { supplier_id: supplierId, charge_on: chargeOn, channel_id: channelId, mcc: "", mnc: "", price: "", currency: "", effective_from: "" };
}

export function costInput(d: CostDraft): { body?: Input<CostPrice>; errors: Errors<CostDraft> } {
  const common = pricingInput(d);
  const errors: Errors<CostDraft> = { ...common.errors };
  if (!d.supplier_id) errors.supplier_id = "选择供应商。";
  if (!d.channel_id) errors.channel_id = "选择通道。";
  if (Object.keys(errors).length || !common.body) return { errors };
  return { errors, body: { ...common.body, channel_id: Number(d.channel_id), correction_of: null } };
}

export interface RateDraft { currency: string; rate: string; effective_from: string }

export function rateDraft(): RateDraft {
  return { currency: "", rate: "", effective_from: "" };
}

/** 汇率按"1 原币等于多少基准币"填十进制，存成微单位（决策 D5）。 */
export function rateInput(d: RateDraft): { body?: Input<CurrencyRate>; errors: Errors<RateDraft> } {
  const errors: Errors<RateDraft> = {};
  const rate = parseMoney(d.rate);
  const from = fromLocalInput(d.effective_from);
  if (!validCurrency(d.currency)) errors.currency = CURRENCY_ERROR;
  if (rate == null || rate <= 0) errors.rate = "正数，最多 6 位小数。";
  if (!from) errors.effective_from = "填写生效时间（北京时间）。";
  if (Object.keys(errors).length || rate == null || !from) return { errors };
  return { errors, body: { currency: d.currency, rate, effective_from: from } };
}
